export default "__VITE_ASSET__eEM2EmLk__"